// extracted by mini-css-extract-plugin
export var link = "_tj-0";